var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, useToast, ToastErrorBox, } from 'shared/components';
import { BUTTON_SUPPORT, GENERIC_ERROR_MESSAGE, GENERIC_ERROR_TITLE, MAIL_SUPPORT, } from 'src/constants/strings';
var TOAST_TOP_CENTER_PROPS = {
    isClosable: true,
    position: 'top',
    containerStyle: { marginTop: '24px' },
    duration: 15000,
};
var EMAIL_SUBJECT = 'Compass Support - Error Report';
export var useErrorToast = function (toastProps) {
    if (toastProps === void 0) { toastProps = TOAST_TOP_CENTER_PROPS; }
    var toast = useToast(toastProps);
    return function (error) {
        var _a, _b, _c;
        var message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : '';
        var emailLink = MAIL_SUPPORT;
        if (isClientError(error)) {
            message = "Compass error message ".concat((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message);
        }
        emailLink += "?subject=".concat(EMAIL_SUBJECT, "&body=").concat(message);
        toast({
            render: function (_a) {
                var onClose = _a.onClose;
                return (_jsx(ToastErrorBox, { variant: "info", title: GENERIC_ERROR_TITLE, message: GENERIC_ERROR_MESSAGE, onClose: onClose, action: _jsx(Button, __assign({ variant: "blueLinks", fontWeight: "600", p: 0, mt: 3, mb: 0, as: "a", href: emailLink }, { children: BUTTON_SUPPORT })) }));
            },
        });
    };
};
/**
 * Type guard to identify between a JS standard error and a graphQL client error, which is what you usually get on a backend response
 *
 * @param {ClientError} error GraphQL response
 * @returns {boolean} identify if this is a graphQL error
 */
function isClientError(error) {
    return (error !== null && typeof error !== 'undefined' && 'response' in error && 'request' in error);
}
